import gql from 'graphql-tag';
export default gql`
  mutation getMLADocusign($applicationId: String!, $isCurrentUserPrimary: Boolean!, $returnUrl: String!) {
    getMLADocusign(applicationId: $applicationId, isCurrentUserPrimary: $isCurrentUserPrimary, returnUrl: $returnUrl) {
      url
    }
  }
`;
